import { render, staticRenderFns } from "./mokuai18.vue?vue&type=template&id=23a9d50b&"
import script from "./mokuai18.vue?vue&type=script&lang=js&"
export * from "./mokuai18.vue?vue&type=script&lang=js&"
import style0 from "./mokuai18.vue?vue&type=style&index=0&id=23a9d50b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports